const extractSignature = require('./extractSignature');
const extractLocation = require('./extractLocation');
const extractPackageEventAction = require('./extractPackageEventAction');
const extractName = require('./extractName');
const locationOrParty = require('./locationOrParty');
const { formatDateTime } = require('gui');

module.exports = function extractPackageEvent(packageEventDto) {
    const packageEvent = {
        time: formatDateTime(packageEventDto.Date, 'LT'),
        date: formatDateTime(packageEventDto.Date, 'L'),
        ticks: packageEventDto.Date,
        isActual: (packageEventDto.Date !== undefined),
        signature: extractSignature(packageEventDto.Signature),
        signatureName: extractName(packageEventDto.Signature),
        location: extractLocation(packageEventDto.Location),
        name: packageEventDto.Description,
        place: locationOrParty(packageEventDto.Location, ''),
        tripId: packageEventDto.TripId || 0,

        eventCode: packageEventDto.EventCode,
        licencePlate: packageEventDto.LicencePlate,
        grossWeight: packageEventDto.GrossWeight,
        volume: packageEventDto.Volume
    };
    negotiateEventCode(packageEvent);
    packageEvent.placeAction = extractPackageEventAction(packageEvent.eventCode, packageEvent.isActual);
    return packageEvent;
}

function negotiateEventCode(event) {
    if(event.eventCode && event.eventCode.indexOf('MANKO_') >= 0) {
        event.missing = true;
        event.eventCode = event.eventCode.substr(6);
    } else
        event.missing = false;
}